const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.stars80027.com";

export { API_BASE_URL };
